import axiosInstance from "../axiosInstance";

export const countryService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/country", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  // fetch: async (limit, skip, text, type) => {
  //   try {
  //     let response = await axiosInstance.get(
  //       `/country?&$limit=${limit || 15}&$skip=${skip || 0}&${
  //         text?.trim() ? `${type}[$search]=${text.trim()}` : ""
  //       }`
  //     );
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  fetch: async (searchValue, query, type) => {
    try {
      let api_query = `/country?`;

      if (searchValue?.trim()) {
        api_query += `${type}[$search]=${searchValue.trim()}`;
      }

      if (query?.length) {
        api_query += `${searchValue?.trim() ? "&" : ""}${query}`;
      }

      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/country/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/country/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/country/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCountryName: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-country-name?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCountryCode2: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-country-code2?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCountryCode3: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-country-code3?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
